import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
  successMessage: "",
  errorMessage: "",
  dataLoading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.successMessage = "Login Success";
      localStorage.setItem("isAuth", true);
      state.dataLoading = false;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.successMessage = "";
      localStorage.clear();
      state.dataLoading = false;
    },
    loaduser: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.successMessage = "Login Success";
      state.dataLoading = false;
    },
    loadingStart: (state) => {
      state.dataLoading = true;
    },
  },
});

export const { login, logout, loaduser,loadingStart } = authSlice.actions;

export const selectAuth = (state) => state.auth;
export default authSlice.reducer;
